/* eslint-disable import/no-cycle */
/* eslint-disable react/jsx-boolean-value */
/* eslint-disable react/no-array-index-key */

'use client';

import React, { useEffect, useRef, useState } from 'react';
import Image from 'next/image';
import Link from 'next/link';
import PropTypes from 'prop-types';
import { getOrganizationPropertiesByHost } from '../../../utils/helpers';
import { TopMenu } from './HeaderTop';
import Main from './MainMenu';
import { nextiasLogo } from '../../../utils/constants';
import LoginButton from './LoginButton';
import { useMiscellaneousData } from '../../../contexts/ssr-miscellaneous-context';

export default function LeftSidebar({ isOpen = false, handleSetLeftSidebar, items = [] }) {
  const { miscellaneousData } = useMiscellaneousData();
  const currentOrg = getOrganizationPropertiesByHost(miscellaneousData?.hostname);
  const sidebarRef = useRef();
  const dropdownRef = useRef();
  const [openDropdown, setOpenDropdown] = useState(null);

  useEffect(() => {
    const handleClickOutside = async (event) => {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        handleSetLeftSidebar(false);
        if (openDropdown !== null) {
          setOpenDropdown(null);
        }
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
  }, [isOpen]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        dropdownRef.current
          && !dropdownRef.current.contains(event.target)
      ) {
        setOpenDropdown(null);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // useEffect(() => {
  //   console.log('items', items);
  // }, [items]);

  return (
    <div
      ref={sidebarRef}
      className={`
        fixed top-0 left-0 h-screen md:w-[45%] w-[73%] bg-white shadow-md z-50
        transform transition-transform duration-300 ease-in-out overflow-auto
        ${isOpen ? 'translate-x-0' : '-translate-x-full'}
      `}
    >
      <div className="p-3 sticky left-0 top-0 bg-white z-50">
        <Link href={`${currentOrg?.organizationName === 'nextias' ? `https://${miscellaneousData?.hostname}` : `https://${miscellaneousData?.hostname}`}`} onClick={() => handleSetLeftSidebar(false)}>
          <Image width={500} height={500} src={currentOrg?.logo || nextiasLogo} alt="logo" className="w-[144px] h-6 xl:w-[175px] xl:h-10" />
        </Link>
      </div>
      <div className="bg-white">
        <ul className="flex flex-col items-start w-full">
          <li className="border-b border-gray-200 py-3 w-full pl-3">
            <Link href={currentOrg?.organizationName === 'nextias' ? 'tel:+8081300200' : 'tel:+9021300500'} className="text-sm text-[#344767] flex items-center" onClick={() => handleSetLeftSidebar(false)}>
              <Image src="https://cdnstatic.nextias.com//call-icon-1756755577127.svg" width={14} height={14} alt="call-icon" className="mr-2" />
              {
                currentOrg?.organizationName === 'nextias' ? (
                  <>
                    80813-00200
                  </>
                ) : (
                  <>
                    90213-00500
                  </>

                )
              }
            </Link>
          </li>
          <li className="border-b border-gray-200 py-3 w-full pl-3">
            <LoginButton handleSetLeftSidebar={handleSetLeftSidebar} />
          </li>
        </ul>
        {
          items && items?.top_header?.length > 0 && (
          <TopMenu menuItems={items} viewType="sidebar" />
          )
        }
        <Main list={items?.main_header} />
      </div>
    </div>
  );
}

LeftSidebar.propTypes = {
  isOpen: PropTypes.bool,
  handleSetLeftSidebar: PropTypes.func.isRequired,
  items: PropTypes.object,
};
